var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all-goals"},[_c('all-goals-test-plans'),_vm._v(" "),_c('home-quiz-b',{staticClass:"pt-0 pb-md-104"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }